import { jsxs, jsx } from "react/jsx-runtime";
const IconChartSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M5 10.833H1.667a.833.833 0 0 0-.834.834v6.666a.833.833 0 0 0 .834.834H5a.833.833 0 0 0 .833-.834v-6.666A.833.833 0 0 0 5 10.833ZM18.334 7.5H15a.833.833 0 0 0-.833.833v10a.833.833 0 0 0 .833.834h3.334a.833.833 0 0 0 .833-.834v-10a.834.834 0 0 0-.834-.833ZM11.667.833H8.334a.833.833 0 0 0-.834.834v16.666a.833.833 0 0 0 .834.834h3.333a.833.833 0 0 0 .833-.834V1.667a.833.833 0 0 0-.833-.834Z" })
    ]
  }
);
export {
  IconChartSvg
};
